<template>
  <div>
    <iframe :src="iframeUrl" title="FatZebra payment widget" class="w-full border-0 h-[600px]" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { usePaymentStore } from '@/store';
import { updateQueryStringParameter } from '@/utils/common-helper';
import { useFeatureTogglesStore } from '@/store/feature-toggles/featureTogglesStore';
import { ENABLE_AB_Testing_FATZEBRA } from '@/constants/feature-toggles';

// Define Composables
// ------------------------------------------------------------- //
const paymentStore = usePaymentStore();
const featureTogglesStore = useFeatureTogglesStore();

// Define Component state
// ------------------------------------------------------------- //
const iframeUrl = ref<string>('');

// Define fuctions
// ------------------------------------------------------------- //
// This is based on the javascript provided by FatZebra
// Ref: https://docs.fatzebra.com/reference/hosted-payment-pages#iframe-and-postmessage-support
async function messageListener(event: any) {
  // Older browsers will have a query-string style data payload
  // Whereas newer browsers will have an object
  let payload = event.data;

  if (typeof event.data == 'string') {
    if (/\[object/i.test(event.data)) {
      alert('Sorry, it looks like there has been a problem communicating with your browser...'); // Raised if the serialization failed
    }

    // Deserialize into an object
    const pairs = payload.split('&');
    payload = {};

    for (const element of pairs) {
      const kv = element.split('=');
      payload[kv[0]] = kv[1];
    }
  }

  if ('data' in payload) {
    const payloadData = payload.data;
    if (payloadData && payloadData.r && payloadData.token) {
      paymentStore.setFzTransactionState(payloadData);
    }

    return true;
  }
}

const isABTestingEnabled = async (): Promise<boolean> => {
  try {
    const isABTestingEnabled = await featureTogglesStore.isFeatureToggleEnabled(ENABLE_AB_Testing_FATZEBRA);
    return isABTestingEnabled;
  } catch (error) {
    console.error('Unable to get feature toggle ', error);
  }
  return false;
};

// Lifecycle hooks
// ------------------------------------------------------------- //
watch(
  () => [paymentStore.reference, paymentStore.amount, paymentStore.buttonText],
  async ([newReference, newAmount, newButtonText]) => {
    const loadIframe =
      newReference === '' ||
      newReference ||
      newAmount ||
      (newButtonText && (!paymentStore.reference || !paymentStore.amount));

    if (loadIframe) {
      const iframeResponse = await paymentStore.getPaymentIframeUrl();
      if (iframeResponse) {
        if ((window as any).csstesturl && (window as any).csstesturlkey && (await isABTestingEnabled())) {
          iframeResponse.url = updateQueryStringParameter(iframeResponse.url, 'css', (window as any).csstesturl);
          iframeResponse.url = updateQueryStringParameter(
            iframeResponse.url,
            'css_signature',
            (window as any).csstesturlkey
          );
        }

        iframeUrl.value = iframeResponse.url;
      }
      (window as any).paymentHost = iframeResponse ? iframeResponse.hostUrl : '';
    } else if (!paymentStore.reference || !paymentStore.amount) {
      console.error('missing reference or amount. please check store');
    }

    /*   if(newReference=='') {
      console.error('missing reference. please check store');
      const iframeResponse = await paymentStore.getPaymentIframeUrl();
        if(iframeResponse)
        {
          iframeUrl.value = iframeResponse.url;
        }
        (window as any).paymentHost = iframeResponse ? iframeResponse.hostUrl : '';  
      return;
    }

    if(newReference || newAmount || newButtonText) {
      if(!paymentStore.reference || !paymentStore.amount) {
        console.error('missing reference or amount. please check store');
      } else {
        const iframeResponse = await paymentStore.getPaymentIframeUrl();
        if(iframeResponse)
        {
          iframeUrl.value = iframeResponse.url;
        }
        (window as any).paymentHost = iframeResponse ? iframeResponse.hostUrl : '';  
      } 
    } */
  },
  { immediate: true }
);

onMounted(async () => {
  window.addEventListener('message', messageListener);
});

onUnmounted(() => {
  window.removeEventListener('message', messageListener);
});
</script>
